<template>
  <div id="app">
    <competition-nav v-if="isCompetitionView" />
    <Nav
      v-else
      @openModal="openModal($event)"
      :userIsLoged="userIsLoged"
      @changeLoged="changeUserIsLoged"
      :windowWidth="windowWidth"
    />
    <router-view class="router-view" />
    <Footer />
    <modalWrapper
      v-if="modal"
      :modalData="modalData"
      :component="modalComponent"
      :outsideClose="outsideClose"
      @closeModal="closeModal()"
      @changeModal="changeModal($event)"
    />
    <loader-wrapper />
    <chat-bot-wrapper />
  </div>
</template>

<script>
// @ is an alias to /src
import competitionNav from "@/components/header/competitionNav.vue";
import Nav from "@/components/header/Nav.vue";
import Footer from "@/components/Footer.vue";
import modalWrapper from "@/components/modalWrapper.vue";
import eventBus from "@/shared/eventBus.js";
import { api } from "@/api";
import { mapState } from "vuex";
import loaderWrapper from "@/components/loaderWrapper.vue";
import chatBotWrapper from "./components/chatBot/chat-bot-wrapper.vue";
export default {
  name: "app",
  components: {
    competitionNav,
    Nav,
    Footer,
    // loginModal,
    // registerModal
    modalWrapper,
    loaderWrapper,
    chatBotWrapper
  },
  data() {
    return {
      modal: false,
      modalComponent: null,
      modalData: null,
      userIsLoged: false,
      windowWidth: window.innerWidth,
      interval: null,
      outsideClose: null
    };
  },
  mounted() {
    this.checkLocale();
    this.checkUserSid();
    this.interval = setInterval(this.checkUserSid, 60000);
    window.addEventListener("resize", this.onResize);
    eventBus.$on("openModal", data => {
      this.openModal(data);
    });
    eventBus.$on("closeModal", () => {
      this.closeModal();
    });
    eventBus.$on("openWSConnection", () => {
      this.setUpWSConection();
    });
    eventBus.$on("changeLoged", data => {
      this.userIsLoged = data;
    });
    this.setNotifications();
    this.setUpWSConection();
  },
  methods: {
    checkLocale() {
      // console.log(this.$route);
      let curLocale = this.$route.params.lang;
      let availableLocales = Object.keys(this.$i18n.messages);
      let params = this.$route.params;
      if (!availableLocales.includes(curLocale)) {
        params.lang = "sr";
        if (this.$route.name) {
        } else {
          this.$router.push({ name: "Home", params: { lang: "sr" } });
        }
        this.$router.replace({
          name: this.$route.name,
          params: params
        });
      }
    },
    setUpWSConection() {
      this.$store.commit("openWSConnection");
      this.connection.onopen = this.onOpen;
      this.connection.onclose = this.onClose;
      this.connection.onerror = this.onError;
      this.connection.onmessage = e => {
        // console.log(this.chatVisible, JSON.parse(e.data));
        let msg = JSON.parse(e.data);
        if (msg.status === "new-connection") {
          this.logout();
          return;
        }
        if (msg.type === "ntf") {
          this.setNotifications();
          eventBus.$emit("refreshNotifications");
        } else {
          if (this.chatVisible) {
            eventBus.$emit("handleMessage", e);
          } else {
            this.setNotifications();
          }
        }
      };
    },
    onOpen(evt) {
      // console.log(evt);
    },
    onClose(evt) {
      // console.log(evt);
      // this.setUpWSConection()
    },
    onError(evt) {
      // console.log(evt);
      // this.setUpWSConection()
    },
    setNotifications() {
      if (localStorage.getItem("sid") && this.userIsLoged) {
        api
          .getNotificationsCount()
          .then(res => {
            this.$store.commit("setNotificationCounters", res.data);
          })
          .catch(e => {
            console.log(e);
          });
      }
    },
    logout() {
      api
        .logout()
        .then(res => {
          localStorage.removeItem("sid");
          this.$emit("changeLoged", false);
          this.$store.commit("setUserName", null);
          this.$store.commit("closeWSConnection");
          if (this.$route.name !== "Home") {
            this.$router.push({
              name: "Home",
              params: { lang: this.$i18n.locale }
            });
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    checkUserSid() {
      // console.log("checking sid");
      if (localStorage.getItem("sid")) {
        api
          .checkSession()
          .then(res => {
            this.userIsLoged = true;
            this.$store.commit("changeUserIsLoged", true);
            this.$store.commit("setUserName", res.data.usr_name);
            if (res.data.admin && res.data.admin === true) {
              this.$store.commit("setUserAdmin", true);
            }
            this.setNotifications();
          })
          .catch(e => {
            // console.log(e.response.request.status);
            if (e.response.request.status === 401) {
              this.userIsLoged = false;
              this.$store.commit("changeUserIsLoged", false);
              this.$store.commit("setUserName", null);
              this.$store.commit("setUserAdmin", false);
              this.navigateToSafePage();
            }
          });
      } else {
        this.userIsLoged = false;
        this.$store.commit("changeUserIsLoged", false);
        this.$store.commit("setUserName", null);
        this.$store.commit("setUserAdmin", false);
        this.setNotifications();
      }
    },
    navigateToSafePage() {
      if (this.$route.meta && this.$route.meta.sidRequired) {
        this.$router.push({
          name: "Home",
          params: { lang: this.$i18n.locale }
        });
      }
      this.setNotifications();
    },
    changeUserIsLoged(data) {
      this.userIsLoged = data;
      this.$store.commit("changeUserIsLoged", data);
      this.setNotifications();
    },
    openModal(evt) {
      this.modal = true;
      this.modalComponent = evt.component;
      this.modalData = evt.modalData;
      this.outsideClose = evt.hasOwnProperty("outsideClose")
        ? evt.outsideClose
        : true;
    },
    closeModal() {
      this.modal = false;
      this.modalComponent = null;
      this.modalData = null;
    },
    changeModal(evt) {
      this.modalComponent = evt.component;
    }
  },
  computed: {
    ...mapState(["connection", "chatVisible"]),
    isCompetitionView() {
      if (
        this.$route.name === "Competitions" ||
        this.$route.name === "Competition" ||
        this.$route.name === "CompetitionRules" ||
        this.$route.name === "CompetitionEntry" ||
        this.$route.name === "CompetitionEntryEdit" ||
        this.$route.name === "CompetitionRankList" ||
        this.$route.name === "CompetitionNoSchool"
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    isCompetitionView: {
      handler(newV) {
        if(newV) {
          localStorage.setItem('locale18', this.$i18n.locale)
          this.$i18n.locale = 'en'
        }else if(newV === false) {
          if(localStorage.getItem('locale18')) {
            this.$i18n.locale = localStorage.getItem('locale18')
          }
        }


      }
    },
    "$i18n.locale": {
      handler(newLocale, oldLocale) {
        if (newLocale !== oldLocale) {
          if (this.$route.params.hasOwnProperty("lang")) {
            this.$router.replace({ params: { lang: this.$i18n.locale } });
          } else {
            this.$router.push({
              name: "Root",
              params: { lang: this.$i18n.locale }
            });
          }
        }
      }
    },
    
  },
  destroyed() {
    eventBus.$off("openModal");
    eventBus.$off("closeModal");
    eventBus.$off("openWSConnection");
    window.removeEventListener("resize", this.onResize);
  }
};
</script>

<style lang="scss">
//v-select custom
#app {
  .vs__search {
    min-width: 120px;
    font-weight: 800;
    font-size: 13px;
    line-height: 21px;
    letter-spacing: 0.02em;
    color: #313131;
    z-index: 0;
  }
  .vs__dropdown-toggle {
    border-radius: 0px;
    border: 1px solid #e8e8e8;
    height: 42px;
    line-height: 42px;
  }
  .vs__open-indicator {
    margin-right: 4px;
  }
}
</style>
<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
// @import url('https://fonts.googleapis.com/css2?family=Catamaran:wght@300;400;500;600;700;800;900&display=swap');
.grecaptcha-badge {
  display: none;
}
body {
  margin: 0px;
}
#app {
  font-family: "Ubuntu";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  // *:not(input) {
  // -webkit-user-select: none; /* Safari */
  // -ms-user-select: none; /* IE 10+ and Edge */
  // user-select: none; /* Standard syntax */
  // }
  input {
    font-family: "Ubuntu";
  }
  input::placeholder {
    font-family: "Ubuntu";
  }
  textarea {
    font-family: "Ubuntu";
    color: $text-color;
  }
}
.toast {
  font-family: "Open sans";
  font-size: 14px;
  font-weight: 700;
  opacity: 1 !important;
  flex-direction: row-reverse;
  border-radius: 5px;
  // height: 63px;
  min-height: 63px;

  .toast-icon {
    margin-right: 20px;
    background-image: url("./assets/icons/toastClose.png") !important;
    width: 13px !important;
    min-width: 13px !important;
    height: 13px !important;
  }
}
.toast.toast-success {
  background: #02d294 !important;
}
.toast.toast-error {
  background: #f3545e !important;
}
.toast.toast-default {
  background: linear-gradient(90.45deg, #8b3d4c -1.87%, #6b3349 101.6%);
}
.toast * {
  opacity: 1;
}
</style>
